import * as React from "react";
import { FormikConsumer } from "formik";

export const Debug = () => (
  <div style={{ maxWidth: "1020px", margin: "0 auto" }}>
    <div
      style={{
        margin: "3rem 0",
        borderRadius: 4,
        background: "#f6f8fa",
        boxShadow: "0 0 1px  #eee inset"
      }}
    >
      <div
        style={{
          textTransform: "uppercase",
          fontSize: 14,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          fontWeight: 500,
          padding: ".5em",
          background: "#17a2b8",
          color: "#fff",
          letterSpacing: "1px"
        }}
      >
        Values
      </div>
      <FormikConsumer>
        {({ validationSchema, validate, ...rest }) => (
          <pre
            style={{
              fontSize: ".65em",
              padding: ".25em .5em",
              overflowX: "scroll"
            }}
          >
            {JSON.stringify(rest.values, null, 2)}
          </pre>
        )}
      </FormikConsumer>
      <div
        style={{
          textTransform: "uppercase",
          fontSize: 14,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          fontWeight: 500,
          padding: ".5em",
          background: "#dc3545",
          color: "#fff",
          letterSpacing: "1px"
        }}
      >
        Errors
      </div>
      <FormikConsumer>
        {({ validationSchema, validate, ...rest }) => (
          <pre
            style={{
              fontSize: ".65em",
              padding: ".25em .5em",
              overflowX: "scroll"
            }}
          >
            {JSON.stringify(rest.errors, null, 2)}
          </pre>
        )}
      </FormikConsumer>
      <div
        style={{
          textTransform: "uppercase",
          fontSize: 14,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          fontWeight: 500,
          padding: ".5em",
          background: "#ffc107",
          color: "#333",
          letterSpacing: "1px"
        }}
      >
        Touched
      </div>
      <FormikConsumer>
        {({ validationSchema, validate, ...rest }) => (
          <pre
            style={{
              fontSize: ".65em",
              padding: ".25em .5em",
              overflowX: "scroll"
            }}
          >
            {JSON.stringify(rest.touched, null, 2)}
          </pre>
        )}
      </FormikConsumer>
    </div>
  </div>
);
